import { handledGetFetch, handledPostFetch } from '../../submodules/shared/utils/api-base';

import { PATHS } from './paths';
import { buildUrl } from './url';

export const getEventProductId = (eventId, productId) =>
    handledGetFetch(buildUrl(PATHS.eventProductId, { event_id: eventId, product_id: productId }));

export const postLab2Exception = (payload) => handledPostFetch(buildUrl(PATHS.labException), payload);

export const getLab2Exception = (eventProductId) => handledGetFetch(buildUrl(PATHS.labExceptionById(eventProductId)));

export const updateLab2Exception = (eventProductId, payload) =>
    handledPostFetch(buildUrl(PATHS.labExceptionById(eventProductId)), payload);
